import React from 'react'
import { useParams } from 'react-router-dom'
import { CompanyDetailProvider } from './context/CompanyDetailProvider'
import { CompanyDetailMain } from './CompanyDetailMain'
import { CompanyDetailWorkflowsProvider } from './context/CompanyDetailWorkflowProvider'
import { EditCompanyNameFlow } from './workflows/EditCompanyNameFlow'
import { AddCancellationPolicyFlow } from './workflows/AddCancellationPolicyFlow'
import { AddMinimumPayPolicyFlow } from './workflows/AddMinimumPayPolicyFlow/AddMinimumPayPolicyFlow'
import { EditMoneyFlow } from './workflows/EditMoneyFlow/EditMoneyFlow'
import { EditPaymentMethodFlow } from './workflows/EditPaymentMethodFlow'
import { InviteUserToCompanyFlow } from './workflows/InviteUserToCompanyFlow'
import { ManageLogoFlow } from './workflows/ManageLogoFlow'
import { EditGeneralDetailsFlow } from './workflows/EditGeneralDetailsFlow'
import { UploadCompanyFileFlow } from './workflows/UploadCompanyFileFlow'
import { EditCompanyFileSchemaFlow } from './workflows/EditCompanyFileSchemaFlow'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'

export const CompanyDetail = () => {
  const { companyId } = useParams()
  return (
    <NuqsAdapter>
      <CompanyDetailProvider companyId={Number(companyId)}>
        <CompanyDetailWorkflowsProvider>
          <CompanyDetailMain />
          <EditCompanyNameFlow />
          <AddCancellationPolicyFlow />
          <AddMinimumPayPolicyFlow />
          <EditMoneyFlow />
          <EditPaymentMethodFlow />
          <InviteUserToCompanyFlow />
          <ManageLogoFlow />
          <EditGeneralDetailsFlow />
          <UploadCompanyFileFlow />
          <EditCompanyFileSchemaFlow />
        </CompanyDetailWorkflowsProvider>
      </CompanyDetailProvider>
    </NuqsAdapter>
  )
}
